import { render } from "./UsersShow.vue?vue&type=template&id=ad5fe5cc"
import script from "./UsersShow.vue?vue&type=script&lang=js"
export * from "./UsersShow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/corrieleech/Actualize/booksmart-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__